// packages/web/src/api/email-templates/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { emailTemplatesList, emailTemplatesGet } from "../generated/sdk.gen.ts";

export const emailTemplatesListOptions = () =>
  queryOptions({
    queryKey: ["email-templates", "list"],
    queryFn: async () => {
      const { data, error } = await emailTemplatesList();
      if (error) throw error;
      if (!data) throw new Error("emailTemplatesList returned no data");
      return data;
    },
  });

export const emailTemplatesGetOptions = (key: string) =>
  queryOptions({
    queryKey: ["email-templates", "detail", key],
    queryFn: async () => {
      const { data, error } = await emailTemplatesGet({ path: { key } });
      if (error) throw error;
      if (!data) throw new Error("emailTemplatesGet returned no data");
      return data;
    },
    enabled: !!key,
  });
